import type { ReactNode } from 'react';

export const symbol_chart_data: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m418-455 59 59q8.07 8 20.53 8 12.47 0 21.47-8l131-131v48q0 12 8.63 20.5 8.62 8.5 21.37 8.5 12 0 21-8.63 9-8.62 9-21.37v-120q0-12-9-21t-21-9H559q-12 0-20.5 9t-8.5 21.5q0 12.5 8.63 21 8.62 8.5 21.37 8.5h47L498-460l-59-59q-9-9-21.47-9-12.46 0-20.53 9L275-397q-9 9-9 21.53 0 12.52 9.39 20.63Q284-346 296.47-346q12.46 0 20.53-9l101-100ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
